const ROMAN_NUMERALS = { i: "1", ii: "2", iii: "3", iv: "4", v: "5", vi: "6", vii: "7", viii: "8", ix: "9", x: "10" }
const LABEL_STOP_TOKENS = new Set([
  "welcome", "hello", "hi", "your", "the", "for", "with",
  "member", "members", "membership",
  "elite", "lifetime",
  "star", "alliance", "oneworld", "skyteam",
  "status", "card"
])

export function normalizeIdentifier(value) {
  return String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "")
}

export function canonicalLabelTokens(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter((token) => token.length > 0)
    .map((token) => (Object.hasOwn(ROMAN_NUMERALS, token) ? ROMAN_NUMERALS[token] : token))
    .filter((token) => !LABEL_STOP_TOKENS.has(token))
}

export function tokenSetMatch(actualTokens, expectedTokens, minChars = 3) {
  if (actualTokens.join("").length < minChars || expectedTokens.join("").length < minChars) return false

  const [shorter, longer] = actualTokens.length <= expectedTokens.length
    ? [actualTokens, expectedTokens]
    : [expectedTokens, actualTokens]
  const longerSet = new Set(longer)
  return shorter.length > 0 && shorter.every((token) => longerSet.has(token))
}

export function identifiersMatch(actual, expected, minLength = 5) {
  const normalizedActual = normalizeIdentifier(actual)
  const normalizedExpected = normalizeIdentifier(expected)
  return normalizedActual.length >= minLength &&
    normalizedExpected.length >= minLength &&
    (normalizedActual === normalizedExpected ||
      normalizedActual.includes(normalizedExpected) ||
      normalizedExpected.includes(normalizedActual))
}

export function captureCheck(actual, expected, mode) {
  const value = (actual || "").trim()
  if (!value) return { accepted: false, value: "", state: "missing" }
  if (!expected) return { accepted: false, value, state: "unknown" }

  const accepted = mode === "identifier"
    ? identifiersMatch(value, expected)
    : tokenSetMatch(canonicalLabelTokens(value), canonicalLabelTokens(expected))

  return { accepted, value, state: accepted ? "matched" : "mismatch" }
}

export function captureChecks(extracted, application) {
  return {
    name: captureCheck(
      extracted.visible_name,
      `${application.first_name || ""} ${application.last_name || ""}`.trim(),
      "label"
    ),
    membership: captureCheck(extracted.visible_membership_id, application.origin_membership_number, "identifier"),
    tier: captureCheck(extracted.visible_tier, application.origin_tier, "label")
  }
}
